import { Injectable } from '@angular/core';
import { from, isObservable, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/core/utils/confirmation-dialog.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class PendingChangesGuard  {
  constructor(private confirmationDialogService: ConfirmationDialogService) {}

  canDeactivate(component: ComponentCanDeactivate): Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    if (!component) {
      return of(true);
    }

    const canDeactivate = component.canDeactivate();

    if (isObservable(canDeactivate)) {
      return canDeactivate.pipe(switchMap((cD) => this.getCanDeactivateObservable(cD)));
    }

    return this.getCanDeactivateObservable(canDeactivate);
  }

  private getCanDeactivateObservable(cD: boolean): Observable<boolean> {
    return cD
      ? of(true)
      : // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
        // when navigating away from your angular app, the browser will show a generic warning message
        // see http://stackoverflow.com/a/42207299/7307355
        from(this.confirmationDialogService.presentAlert('general.phrase.unsavedChanges', 'OK'));
  }
}
